/**
 * Created by Pankaj on 06/Dec/2019.
 */
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TweenLite} from "gsap";
import {IPosition, RomanEmpireBetLineWinData, RomanEmpireInitialWPController} from "./RomanEmpireInitialWPController";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

/**
 * AnimatedMultiplier class to handle all multiplier animation stuffs over bet lines
 * in Genie Re spin.
 */
export class AnimatedMultiplier extends PIXI.BitmapText {
    private _targetPosition: IPosition[] = [];
    private _bg: PIXI.Sprite;
    public static MULTIPLIER_STYLE: PIXI.TextStyle | any = {
        font: {
            name: "NumbersWinCountUp",
            size: 24
        },
        align: "center",
        tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    constructor(betLineWinData: RomanEmpireBetLineWinData) {
        super("x" + betLineWinData.extraWildMultiplier, AnimatedMultiplier.MULTIPLIER_STYLE);
        this.init(betLineWinData);
    }

    private init(betLineWinData: RomanEmpireBetLineWinData) {
        this.setInitialPosition(Helper.getSymbolPositions(0, betLineWinData.betLine[0]));
        this.setTargetPosition(betLineWinData);
        this.anchor = 0.5;
        this.alpha = 0.8; //Added to fix #200
        //this.scale.set(0.5, 0.5); //commented to fix #200
        //this.addBgPatch(betLineWinData.extraWildMultiplier);
        this.visible = false;
    }

    private addBgPatch(textVal: number) {
        this._bg = new PIXI.Sprite(GameResources.getTextures("patchCircle")[0]);
        this._bg.tint = 0xFFBE1F;
        //this._bg.tint = 0x000000;
        this._bg.alpha = 0.8;
        this._bg.anchor.set(0.5, 0.5);
        this._bg.scale.set(textVal > 9 ? 1 : 0.7);
        this._bg.position.set(0, 15);
        this.addChildAt(this._bg, 0);
    }

    private setInitialPosition(pos: number[]) {
        this.position.set(pos[0], pos[1]);
    }

    private setTargetPosition(betLineWinData: RomanEmpireBetLineWinData) {
        const maxLen: number = Math.min(3, betLineWinData.nrOfSymbols);
        for (let j = 0; j < maxLen; j++) {
            let targetPos = Helper.getSymbolPositions(j, betLineWinData.betLine[j]);
            this._targetPosition.push({x: targetPos[0], y: targetPos[1]});
        }
    }

    public getAnimationTween(): TweenLite {
        return TweenLite.to(this, RomanEmpireInitialWPController.BET_LINE_MIN_DURATION, {
            bezier: this._targetPosition, onComplete: () => {
                //this.scaleOut();
                this.blink();
                //this.visible = false;
            },
            onUpdate: function () {
                //const accelerationValue : number = Math.sin(this.progress() * 3) * 0.5 + 0.5;
                if (this.progress() < 0.3) {
                    this.target.scale.set(0.6);
                    this.target.alpha = 0.7;
                } else if (this.progress() < 0.6) {
                    this.target.scale.set(0.8);
                    this.target.alpha = 0.8;
                } else if (this.progress() < 1) {
                    this.target.scale.set(0.9);
                    this.target.alpha = 1;
                }
                //this.target.scale.set(accelerationValue); //commented to fix #200
                //this.target.alpha.set(accelerationValue); //commented to fix #200
            },
            onStart: () => {
                this.visible = true;
                this.scale.set(0.5);
                this.alpha = 0.7;
            }
        })
    }

    private blink() {
        return TweenLite.to(this.scale, 0.16, {
            x: 1.4, y: 1.4, onComplete: () => TweenLite.to(this.scale, 0.2, {x: 0.8, y: 0.8, onComplete: () => this.fadeOut()})
        });
    }

    private fadeOut(): TweenLite {
        return TweenLite.to(this, 0.2, {
            alpha: 0, onComplete: () => {
                this.visible = false
            }
        });
    }

    private scaleOut(): TweenLite {
        return TweenLite.to(this.scale, 0.1, {
            x: 0, y: 0, onComplete: () => {
                this.visible = false
            }
        });
    }
}
